// extracted by mini-css-extract-plugin
export default {"box":"ArrivalCard_box__7RhsU"};